import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const InputWrapper = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  //align-items: center;
  width: 100%;
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  background: ${(p) => p.theme.palette.common.white};
  border-radius: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(0.25, 2)};

  &:focus-visible {
    border: 1px solid ${(p) => p.theme.palette.primary[500]};
  }

  &.focused {
    border-color: ${(p) => p.theme.palette.primary[500]};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background: ${(p) => p.theme.palette.common.white};
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    /* width: 0; */
    /* min-width: 30px; */
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`;
